<script setup lang="ts">
import type { Component } from "vue";
import { computed } from "vue";
import {
  CheckCircleIcon,
  CircleIcon,
  ClockIcon,
  XCircleIcon,
} from "lucide-vue-next";
import { Badge } from "@/components/ui/badge";
import type { ToolUiState } from "../../../types/chat";

const props = defineProps<{
  state: ToolUiState | string;
}>();

const LABELS: Record<string, string> = {
  "input-streaming": "Pending",
  "input-available": "Running",
  "approval-requested": "Awaiting Approval",
  "approval-responded": "Responded",
  "output-available": "Completed",
  "output-error": "Error",
  "output-denied": "Denied",
};

const ICONS: Record<string, Component> = {
  "input-streaming": CircleIcon,
  "input-available": ClockIcon,
  "approval-requested": ClockIcon,
  "approval-responded": CheckCircleIcon,
  "output-available": CheckCircleIcon,
  "output-error": XCircleIcon,
  "output-denied": XCircleIcon,
};

const label = computed(() => LABELS[props.state] ?? props.state);
const icon = computed<Component>(() => ICONS[props.state] ?? CircleIcon);

const iconClass = computed(() => ({
  "size-4": true,
  "animate-pulse": props.state === "input-available",
  "text-yellow-600": props.state === "approval-requested",
  "text-blue-600": props.state === "approval-responded",
  "text-green-600": props.state === "output-available",
  "text-red-600": props.state === "output-error",
  "text-orange-600": props.state === "output-denied",
}));
</script>

<template>
  <Badge class="gap-1.5 rounded-full text-xs" variant="secondary">
    <component :is="icon" :class="iconClass" />
    <span>{{ label }}</span>
  </Badge>
</template>
